import { render, staticRenderFns } from "./procedure2.vue?vue&type=template&id=aac9f6c8&scoped=true"
import script from "./procedure2.vue?vue&type=script&lang=js"
export * from "./procedure2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac9f6c8",
  null
  
)

export default component.exports